<!-- 公共底部 -->
<template>
  <div class="base-footer">
    <!-- <img src="@/assets/imgs/logo_white.png" /> -->
    <div class="copyright">
      <p>Copyright © 2025 河南理工大学应急管理学院</p>
      <p>萌泰数据提供技术支持</p>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.base-footer {
  width: 100%;
  height: $footer-height;
  background-color: $theme-color;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  img {
    height: 36px;
  }
  .copyright {
    text-align: center;
    font-size: 13px;
    p {
      line-height: 20px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .base-footer {
    gap: 10px;
    img {
      height: 20px;
    }
    .copyright {
      font-size: 12px;
      p {
        line-height: 18px;
      }
    }
  }
}
</style>
